import PropTypes from 'prop-types';
// Subset of UIComponents' OptionTypes that we want to support
// See https://git.hubteam.com/HubSpot/UIComponents/blob/master/UIComponents/static-3.6189/js/types/OptionTypes.js

export const SingleValueType = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]);
export const OptionType = PropTypes.shape({
  text: PropTypes.string,
  value: SingleValueType,
  help: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
});
export const OptionGroupType = PropTypes.shape({
  options: PropTypes.arrayOf(OptionType.isRequired).isRequired,
  text: PropTypes.string
});
export const OptionOrGroupType = PropTypes.oneOfType([OptionGroupType, OptionType]);